/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export const AddBtnEvent = {
  /*
   * 点击添加按钮
   * @param event
   */
  addClick: (_event: PointerEvent) => true,
};
